export default __webpack_public_path__ + "static/media/winner-prize.4b7b2e2f.svg";